module.exports = __webpack_public_path__ + "img/Dorothe_Engelbretsdotter_portrett.8aace685.jpg";